module.exports = __webpack_public_path__ + "static/img/logo.d323446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/logo.png
// module id = /NBh
// module chunks = 1